// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import SiHaDocumentationStatusEnumResourceViewModel from '../../../../viewModel/resource/SiHaDocumentationStatusEnumResourceViewModel';
import SiHaDocumentationResourceViewModel from '../../../../viewModel/resource/SiHaDocumentationResourceViewModel';
import SiHaDocumentationResourceDTO from '../../dto/resource/SiHaDocumentationResourceDTO';

export default abstract class SiHaDocumentationResourceModel extends BaseModel<SiHaDocumentationResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  * @type {uuid}
  */
  get shareId() { return this.dto.shareId; }
  set shareId(value) { this.dto.shareId = value; }
  /**
  * @type {int64}
  */
  get userId() { return this.dto.userId; }
  set userId(value) { this.dto.userId = value; }
  /**
  * @type {int32}
  */
  get siHaDocumentationStatus() { return this.dto.siHaDocumentationStatus; }
  set siHaDocumentationStatus(value) { this.dto.siHaDocumentationStatus = value; }
  /**
  */
  get constructionPlanDocumentExternalId() { return this.dto.constructionPlanDocumentExternalId; }
  set constructionPlanDocumentExternalId(value) { this.dto.constructionPlanDocumentExternalId = value; }
  /**
  */
  get locationMapDocumentExternalId() { return this.dto.locationMapDocumentExternalId; }
  set locationMapDocumentExternalId(value) { this.dto.locationMapDocumentExternalId = value; }
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get remark() { return this.dto.remark; }
  set remark(value) { this.dto.remark = value; }
  /**
  */
  get projectNumber() { return this.dto.projectNumber; }
  set projectNumber(value) { this.dto.projectNumber = value; }
  /**
  */
  get clientCompanyName() { return this.dto.clientCompanyName; }
  set clientCompanyName(value) { this.dto.clientCompanyName = value; }
  /**
  */
  get clientAddressLine() { return this.dto.clientAddressLine; }
  set clientAddressLine(value) { this.dto.clientAddressLine = value; }
  /**
  */
  get clientPostalCode() { return this.dto.clientPostalCode; }
  set clientPostalCode(value) { this.dto.clientPostalCode = value; }
  /**
  */
  get clientCity() { return this.dto.clientCity; }
  set clientCity(value) { this.dto.clientCity = value; }
  /**
  */
  get clientFirstName() { return this.dto.clientFirstName; }
  set clientFirstName(value) { this.dto.clientFirstName = value; }
  /**
  */
  get clientLastName() { return this.dto.clientLastName; }
  set clientLastName(value) { this.dto.clientLastName = value; }
  /**
  */
  get clientEMail() { return this.dto.clientEMail; }
  set clientEMail(value) { this.dto.clientEMail = value; }
  /**
  */
  get clientPhoneNumber() { return this.dto.clientPhoneNumber; }
  set clientPhoneNumber(value) { this.dto.clientPhoneNumber = value; }
  /**
  */
  get addressLine() { return this.dto.addressLine; }
  set addressLine(value) { this.dto.addressLine = value; }
  /**
  */
  get city() { return this.dto.city; }
  set city(value) { this.dto.city = value; }
  /**
  */
  get postalCode() { return this.dto.postalCode; }
  set postalCode(value) { this.dto.postalCode = value; }
  /**
  * @type {date-time}
  */
  get nextInspectionDueDate() { return this.dto.nextInspectionDueDate; }
  set nextInspectionDueDate(value) { this.dto.nextInspectionDueDate = value; }
  /**
  */
  get safetyHookIds() { return this.dto.safetyHookIds; }
  set safetyHookIds(value) { this.dto.safetyHookIds = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    this.dto.shareId = qs.shareid;
    value = Number.parseFloat(qs.userid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.userId = value;
    value = Number.parseFloat(qs.sihadocumentationstatus);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.siHaDocumentationStatus = value;
    this.dto.constructionPlanDocumentExternalId = qs.constructionplandocumentexternalid;
    this.dto.locationMapDocumentExternalId = qs.locationmapdocumentexternalid;
    this.dto.title = qs.title;
    this.dto.remark = qs.remark;
    this.dto.projectNumber = qs.projectnumber;
    this.dto.clientCompanyName = qs.clientcompanyname;
    this.dto.clientAddressLine = qs.clientaddressline;
    this.dto.clientPostalCode = qs.clientpostalcode;
    this.dto.clientCity = qs.clientcity;
    this.dto.clientFirstName = qs.clientfirstname;
    this.dto.clientLastName = qs.clientlastname;
    this.dto.clientEMail = qs.clientemail;
    this.dto.clientPhoneNumber = qs.clientphonenumber;
    this.dto.addressLine = qs.addressline;
    this.dto.city = qs.city;
    this.dto.postalCode = qs.postalcode;
    this.dto.nextInspectionDueDate = qs.nextinspectionduedate;
  }
}
